import Wechat from "../../../utils/wechat"
import * as langs from "../../../constants/langs"
import * as types from "../mutation-types"
import cookies from "../../../utils/cookies"
import * as ua from "../../../utils/ua"
import Raven from "raven-js"
import * as url from "../../../utils/url"
import * as report from "../../../utils/report"
import * as request from "../../../utils/request"
import * as Sentry from "@sentry/browser"
import * as storeUserApi from "../../../api/user"
import { parsePskeyQQLogin } from "@tencent/midas-util"
import { loginStateUtil } from "../../../utils/loginState"
const state = {
  openid: "",
  openkey: "",
  sessionId: "",
  sessionType: "",
  wxAppid2: "",
  qqAppid: "",

  accountType: "",
  userAgent: ua.getUserAgent(),
  nickname: "",
  avatar: "",
  partition: "",
  area: "",
  platid: "",
  selectedZone: "",
  gameBalance: -1
}

const getters = {
  loginState: state => {
    let session = {
      openid: state.openid,
      openkey: state.openkey,
      session_id: state.sessionId,
      session_type: state.sessionType
    }
    if (state.wxAppid2) {
      session.wx_appid = state.wxAppid2
    } else if (state.qqAppid) {
      session.qq_appid = state.qqAppid
    }
    return session
  },
  accountType: state => state.accountType,
  userAgent: state => state.userAgent,
  avatar: state => state.avatar,
  nickname: state => state.nickname,
  partitionInfo: state => {
    return {
      game_platform_id: state.platid,
      area: state.area,
      partition: state.partition
    }
  },
  selectedZone: state => state.selectedZone,
  gameBalance: state => state.gameBalance
}

const actions = {
  getLoginState({ state, commit, dispatch }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      if (!state.openid || !state.openkey) {
        // 如果url上传入登录态，则优先取url
        if (url.getParam("openid") && url.getParam("openkey") && url.getParam("sessionid") && url.getParam("sessiontype")) {
          let loginState = {
            openid: url.getParam("openid"),
            openkey: url.getParam("openkey"),
            sessionId: url.getParam("sessionid"),
            sessionType: url.getParam("sessiontype")
          }
          if (url.getParam("wxAppid2")) loginState.wxAppid2 = url.getParam("wxAppid2")
          if (url.getParam("qq_appid")) loginState.qqAppid = url.getParam("qq_appid")

          if (loginStateUtil(loginState).isQQSessionType) {
            loginState.accountType = "qq"
          }
          if (langs.WX_SESSION_TYPE.indexOf(loginState.sessionType) > -1) {
            loginState.accountType = "wechat"
          }

          commit(types.SET_USER_LOGIN_STATE, loginState)

          resolve(loginState)
        } else if (state.userAgent.weixin) {
          dispatch("getWechatLoginState", {})
            .then(loginState => {
              resolve(loginState)
            })
            .catch(() => {
              reject()
            })
        } else if (state.userAgent.QQ) {
          let pskeyLoginState = await parsePskeyQQLogin({ s_url: location.href })
          let loginState = {
            openid: pskeyLoginState?.uin || cookies.get("uin").substr(1) * 1,
            openkey: pskeyLoginState?.pskey || cookies.get("skey"),
            sessionId: "uin",
            sessionType: pskeyLoginState?.pskey ? pskeyLoginState?.sessiontype : "skey",
            accountType: "qq"
          }
          commit(types.SET_USER_LOGIN_STATE, loginState)
          commit(types.SET_USER_AVATAR, `//q.qlogo.cn/g?b=qq&nk=${loginState.openid}&s=100`)

          resolve(loginState)
        } else if (window._msdkLoginParams && state.userAgent.msdk) {
          if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
            let loginState = {
              openid: _msdkLoginParams.openid,
              openkey: _msdkLoginParams.access_token,
              sessionId: "hy_gameid",
              sessionType: "wc_actoken",
              wxAppid2: _msdkLoginParams.appid,
              accountType: "wechat"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            // dispatch("getWechatNicknameAndAvatar")
            resolve(loginState)
          } else if (_msdkLoginParams.acctype === "qq") {
            /**
             *  {
                  "acctype": "qq",
                  "appid": "1104922185",
                  "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
                  "access_token": "E51744B676BDABA33EF0E9160609E279",
                  "pay_token": "45DD6BF183D747520BCF974977835EFF",
                  "platid": "0"
                }
             */
            let loginState = {
              openid: _msdkLoginParams.openid,
              openkey: _msdkLoginParams.access_token,
              sessionId: "openid",
              sessionType: "kp_accesstoken",
              qqAppid: _msdkLoginParams.appid,
              accountType: "qq"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            resolve(loginState)
          } else {
            reject("无登陆态")
          }
        } else if (url.getParam("currentAccountType") === "Wechat") {
          dispatch("getWechatLoginState", {})
            .then(loginState => {
              resolve(loginState)
            })
            .catch(() => {
              reject()
            })
        } else if (QC && QC.Login.check()) {
          // 浏览器场景 - QQ互联登录
          QC.Login.getMe((openid, accessToken) => {
            let loginState = {
              openid,
              openkey: accessToken,
              sessionId: "openid",
              sessionType: "kp_accesstoken",
              qqAppid: "101502376"
            }
            commit(types.SET_USER_LOGIN_STATE, {
              ...loginState,
              accountType: "qq"
            })
            QC.api("get_user_info").success(function (res) {
              commit(types.SET_USER_AVATAR, res.data.figureurl_qq_2.replace(/https?/gi, "https"))
            })
            resolve(loginState)
          })
        } else {
          // dispatch("reportUserAction", {
          //   iformat: config.REPORT.PAGEVIEW.OUTGAME_BARGAIN_NON_WECHAT_AND_QQ
          // })
          reject("无登陆态")
        }
      } else {
        resolve({
          openid: state.openid,
          openkey: state.openkey,
          sessionId: state.sessionId,
          sessionType: state.sessionType,
          wxAppid2: state.wxAppid2
        })
      }
    })
      .then(loginState => {
        Sentry.configureScope(scope => {
          scope.setUser({ id: loginState.openid, ...loginState })
        })
        return loginState
      })
      .catch(res => {
        Raven.captureException(new Error("get-login-state-error"), {
          tags: { type: "get-login-state-error" },
          extra: {
            res,
            state
          }
        })

        throw res
      })
  },

  // 获取微信登录态
  getWechatLoginState({ commit }, { forceOAuth = false, redirectUrl = "" }) {
    return new Promise((resolve, reject) => {
      let wechat = new Wechat({
        getDetail: 1,
        forceOAuth
      })
      if (wechat.init({ redirectUrl })) {
        wechat.getOpenid({
          onSuccess: function () {
            commit(types.SET_USER_LOGIN_STATE, {
              openid: this.openid,
              openkey: this.accessToken,
              sessionId: "hy_gameid",
              sessionType: "wc_actoken",
              wxAppid2: "wx951bdcac522929b6",
              accountType: "wechat"
            })
            if (this.info.headimgurl) {
              commit(types.SET_USER_AVATAR, this.info.headimgurl.replace(/https?/gi, "https"))
            }
            if (this.info.nickname) {
              commit(types.SET_USER_NICKNAME, this.info.nickname)
            }
            resolve({
              openid: this.openid,
              openkey: this.accessToken,
              userInfo: this.info
            })
          },
          onError: () => {
            reject()
          }
        })
      }
    }).then(result => {
      if (url.getParam("code")) {
        // 微信授权登录成功后，如果页面链接上有code，则需要把code删掉，避免后续再次调用获取登录态的时候用过期的code去跳授权
        history.replaceState(
          {},
          "",
          url.addGetParam(
            {
              r: Math.random()
            },
            url.delParam(["code", "state"], location.href)
          )
        )
      }
      return result
    })
  },
  getInGameZoneInfo({ commit }, { zoneJs, zoneKey }) {
    const partition = url.getParam("partition")
    const userAgent = ua.getUserAgent()
    return request.getScript(zoneJs).then(() => {
      const zoneInfo = window[zoneKey]?.STD_DATA?.find(item => item.v == partition)
      commit(types.SET_SELECTED_ZONE, {
        zoneName: zoneInfo.t,
        zoneId: zoneInfo.vMidas || zoneInfo.v
      })
      commit(types.SET_PARTITION_INFO, {
        platid: userAgent.iOS ? 0 : 1,
        area: zoneInfo.c,
        partition: zoneInfo.v
      })
    })
  },
  getWechatNicknameAndAvatar({ getters, commit }) {
    request
      .ajax({
        url: "//pay.qq.com/cgi-bin/account/get_wechat_userinfo.cgi",
        data: {
          get_detail: 2,
          openid: getters.loginState.openid,
          access_token: encodeURIComponent(getters.loginState.openkey)
        }
      })
      .then(res => {
        if (res.resultcode == 0) {
          commit(types.SET_USER_AVATAR, res.resultinfo.obj.headimgurl.replace(/https?/gi, "https"))
          commit(types.SET_USER_NICKNAME, res.resultinfo.obj.nickname)
        }
      })
  },

  reportUserAction({ getters }, params) {
    let data = {
      3: getters.loginState.openid,
      8: JSON.stringify(params.resultInfo || ""),
      // 19: getters.currentItem && getters.currentItem.code,
      13: 1,
      21: params.iformat,
      26: `${getters.pfSource}-${getters.pf || "pay_html5"}_-html5`,
      24: url.getParam("offerId") || getters.offerId,
      37: getters.loginState.session_id,
      43: getters.loginState.session_type,
      41: getters.loginState.wx_appid,
      50: navigator.userAgent,
      // 51: getters.aid,
      36: location.href
    }

    setTimeout(() => {
      report.dataReport(data)
    }, 0)
  },
  /**
   * 用户订阅
   * @param thumbs_up_type
   * @param subject_type
   * @param subject_id
   * @param getters
   */
  getUserSubscribe({ getters }, { offerId, action, groups = "" }) {
    let params = {
      ...getters.loginState,
      offerId: offerId || getters.offerId,
      sandbox: getters.sandbox,
      action,
      pf: `${getters.pfSource}-${getters.pf}-html5`,
      groups: groups
    }
    return storeUserApi.getSubscribe(params)
  },
  queryGameBalance({ getters, commit }) {
    return storeUserApi
      .queryGameCoinBalance({
        loginState: getters.loginState,
        offerId: getters.offerId,
        sandbox: getters.sandbox,
        pf: `${getters.pfSource}-${getters.pf}-${getters.userAgent.iOS ? "iap" : "android"}`,
        zoneId: getters.partitionInfo.partition
      })
      .then(res => {
        commit("SET_GAME_BALANCE", res?.info?.game_coin?.balance)
      })
      .catch(err => {
        console.error(err)
      })
  }
}
const mutations = {
  [types.SET_USER_LOGIN_STATE](state, { openid, openkey, sessionId, sessionType, wxAppid2, qqAppid, accountType }) {
    state.openid = openid
    state.openkey = openkey
    state.sessionId = sessionId
    state.sessionType = sessionType
    state.accountType = accountType
    wxAppid2 && (state.wxAppid2 = wxAppid2)
    qqAppid && (state.qqAppid = qqAppid)
  },
  [types.SET_USER_AVATAR](state, avatar) {
    state.avatar = avatar
  },
  [types.SET_USER_NICKNAME](state, nickname) {
    state.nickname = nickname
  },
  [types.SET_SELECTED_ZONE](state, zoneInfo) {
    state.selectedZone = zoneInfo
  },
  [types.SET_PARTITION_INFO](state, info) {
    state.partition = info.partition
    state.area = info.area
    state.platid = info.platid
  },
  ["SET_GAME_BALANCE"](state, balance) {
    state.gameBalance = balance
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
